// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type { EnvironmentList } from '../models/index';
import {
  EnvironmentListFromJSON,
  EnvironmentListToJSON,
} from '../models/index';

/**
 *
 */
export class EnvironmentsApi extends runtime.BaseAPI {
  /**
   * Environments are derived from catalog contents: one entry per distinct environment that has at least one entity. Intended for discovery by consumers that scope further calls per environment.
   * List catalog environments
   */
  async v1EnvironmentsGetRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<EnvironmentList>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/environments`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      EnvironmentListFromJSON(jsonValue),
    );
  }

  /**
   * Environments are derived from catalog contents: one entry per distinct environment that has at least one entity. Intended for discovery by consumers that scope further calls per environment.
   * List catalog environments
   */
  async v1EnvironmentsGet(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<EnvironmentList> {
    const response = await this.v1EnvironmentsGetRaw(initOverrides);
    return await response.value();
  }
}
